import { Snackbar, Typography } from '@mui/joy';
const Toast = (
    { open, setOpen, message}
) => {

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  return (
    <>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Typography color='danger'>
            {message}
        </Typography>
      </Snackbar>
    </>
  );
};

export default Toast;
